import { Wrapper, BtnTabBar, BtnTabBarCustom } from './styles'
import { TabBarProps } from './types'

function TabBar({ show = true, children }: TabBarProps) {
  return show ? <Wrapper>{children}</Wrapper> : null
}

export default TabBar
export { BtnTabBar, BtnTabBarCustom }
